import { render } from "./NoAgent.vue?vue&type=template&id=4851a135&scoped=true"
import script from "./NoAgent.vue?vue&type=script&lang=js"
export * from "./NoAgent.vue?vue&type=script&lang=js"

import "./NoAgent.vue?vue&type=style&index=0&id=4851a135&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4851a135"]])

export default __exports__